import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=82e75964&scoped=true&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"
import style0 from "./Header.vue?vue&type=style&index=0&id=82e75964&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82e75964",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Header: require('/var/www/linza-front/linza-front-20251107075108/components/common/Header.vue').default,DialogSearch: require('/var/www/linza-front/linza-front-20251107075108/components/common/DialogSearch.vue').default,DialogAuthorization: require('/var/www/linza-front/linza-front-20251107075108/components/common/DialogAuthorization.vue').default,MobileMenu: require('/var/www/linza-front/linza-front-20251107075108/components/common/MobileMenu.vue').default})
